<nx-card class="table-card-viewer">
  <page-list-view-header
    [newSupplier]="new()"
    [title]="headerTitle"
    [(viewChangers)]="viewChangers"
    [menuWantedInMobileView]="true"
    [onlyAddNewButtonWantedInMobileView]="false"
  ></page-list-view-header>

  <div nxLayout="grid">
    <div nxRow="" class="nx-margin-bottom-s">
      <div nxCol="12,12,12,6" class="onlyActive-col">
        <nx-switcher labelSize="small" name="onlyActive"
          [ngModel]="onlyActive"
          (ngModelChange)="onOnlyActiveChange($event)">
          {{ 'contract.onlyActive' | caption }}
        </nx-switcher>
      </div>
      <div nxCol="12,12,12,6">
        <nx-formfield label="{{'contract.filterKey.activeAt' | caption}}" appearance="outline" floatLabel="always">
          <input name="tableActiveAt" type="text" nxInput nxDatefield
            [datepicker]="tableActiveAtPicker"
            [readonly]="onlyActive"
            [(ngModel)]="tableActiveAt"
            (dateChange)="onTableActiveAtChange()"/>
            <nx-datepicker-toggle [for]="tableActiveAtPicker" nxFormfieldSuffix [disabled]="onlyActive"></nx-datepicker-toggle>
            <nx-datepicker #tableActiveAtPicker></nx-datepicker>
          </nx-formfield>
        </div>
      </div>

    <div nxRow="">
      <div nxCol="12">
        @if (!viewChangers['calendarView'].show) {
          <div class="aquila-table-custom">
            <aquila-table [rows]="models" [colDefinitions]="colDef" [actionConfig]="actionDef"
              [showAsList]="mobile" [elementsPerPage]="pageSize"
            ></aquila-table>
          </div>
        }
        <!--      <ng-container *ngIf="viewChangers['mapView'].show">-->
        <!--        <app-map [models]="mapModels" [startZoom]="8" [markerClickSupplier]="markerClick()" [showYourPosition]="false"></app-map>-->
      <!--      </ng-container>-->
      @if (viewChangers['calendarView'].show) {
        @if (gantModels) {
          <app-gant-chart #gantChartComponent [cookieKey]="GANT_FILTER_COOKIE_KEY" [options]="options"
          [models]="gantModels" [service]="service"></app-gant-chart>
        }
      }
    </div>
  </div>
  </div>
</nx-card>


<ng-template #test let-value="value">
  @for (role of value; track role) {
    {{ role }},
  }
</ng-template>


